

























import { COMPANY_STATUS } from 'gl-ms-offers';
import offerMixins from '@/helpers/offers/offerMixin';
import { ADD_LANES, laneFormData } from '@/store/modules/offersModule';
import LanesAdd from './addLanes.vue';

export default {
    mixins: [offerMixins],
    components: {
        LanesAdd,
    },
    computed: {
        showAddButton(this: any) {
            return this.offersData.status !== COMPANY_STATUS.CLOSED;
        },
    },
    methods: {
        addNewLane(this: any) {
            const newLane = { ...laneFormData, ...{ isNew: true, isEditing: false } };
            this.$store.commit(ADD_LANES, newLane);
        },
    },
};
